export const parentsData = [
    {
      iconComponent: 'parent-icon',
      title: 'УЧЕНИК/РОДИТЕЛ',
      details: [
        {
            text: 'Преглед на седмичната програма'
        },
        {
            text: 'Преглед на информацията за детето/ученика в институцията – отсъствия, оценки, забележки и др.'
        },
        {
            text: 'Подаване на заявления за отсъствия по семейни причини'
        },
        {
            text: 'Справки по месеци и предмети'
        }
      ]
    },
    {
      iconComponent: 'mobile-icon',
      title: 'МОБИЛНО<br>ПРИЛОЖЕНИЕ',
      details: [
        {
            text: 'Преглед на въведената от учителя информация за конкретното дете/ученик'
        },
        {
            text: 'Преглед на учебната програма'
        },
        {
            text: 'Информиране за различни събития и обмен на съобщения с учителите на детето/ученика'
        },
      ]
    },
];
